export const isTenStepConsultService = (service) => {
  const normalizedCode = String(service?.servicecode || service?.code || '').trim().toUpperCase();
  const normalizedName = String(service?.servicename || service?.description || '').trim().toLowerCase();

  return (
    normalizedCode === 'GEN CONSULT' ||
    normalizedCode === 'CLINIC CONSULT' ||
    normalizedCode === 'CLINIC CONSULT EXT' ||
    normalizedCode === 'PCDT' ||
    normalizedName.includes('general consult') ||
    normalizedName.startsWith('clinic consult') ||
    normalizedName.includes('pcdt consult')
  );
};

export const getPrimaryConsultServiceId = (items) => {
  const arr = Array.isArray(items) ? items : [];
  const consultItem = arr.find((it) => isTenStepConsultService(it) && (it?.serviceid || it?.serviceId));
  return consultItem?.serviceid ?? consultItem?.serviceId ?? null;
};

export const getRouteForService = (service) => {
  const normalizedCode = String(service?.servicecode || "").trim().toUpperCase();
  const normalizedName = String(service?.servicename || "").trim().toLowerCase();

  const serviceRouteByCode = {
    "BP": "/customer/clinic/blood-pressure-test",
    "GLUC": "/customer/clinic/glucose-test",
    "CHOLES": "/customer/clinic/cholesterol-test",
    "LIPOGRAM": "/customer/clinic/lipogram-test",
    "PEAK FLOW": "/customer/clinic/peak-flow-test",
    "URINE": "/customer/clinic/urine-dipstick-test",
    "IRON": "/customer/clinic/hemoglobin-test",
    "HIV": "/customer/clinic/hiv-test",
    "EAR": "/customer/clinic/ear-syringing",
    "WOUND CARE 1": "/customer/clinic/wound-care",
    "WOUND CARE 2": "/customer/clinic/wound-care",
    "ADMIN": "/customer/clinic/injection",
    "ADMIN PEAK": "/customer/clinic/injection",
    "NEBULISE": "/customer/clinic/nebulisation",
    "PAP SMEAR": "/customer/clinic/pap-smear",
    "FAMILY PLANNING": "/customer/clinic/family-planning",
    "BABY ADMIN": "/customer/clinic/baby-immunization",
    "CONSULT": "/customer/clinic/diet-consult-weekly",
    "DIET PLUS": "/customer/clinic/diet-plus-injection",
    "DIABETES": "/customer/clinic/diabetes-consult",
    "HRA CASH": "/customer/clinic/health-risk-assessment",
    "MENOPAUSE": "/customer/clinic/metabolic-consult",
    "MOMENTUM HRA": "/customer/clinic/momentum-hra",
    "VITALITY CASH": "/customer/clinic/discovery-vitality",
    "VITALITY MA": "/customer/clinic/discovery-vitality",
    "WELLNESS": "/customer/clinic/wellness-screening",
  };

  const routeForService =
    serviceRouteByCode[normalizedCode] ||
    (normalizedName.includes("blood pressure") ? "/customer/clinic/blood-pressure-test" : null) ||
    (normalizedName.includes("glucose") ? "/customer/clinic/glucose-test" : null) ||
    (normalizedName.includes("cholesterol") ? "/customer/clinic/cholesterol-test" : null) ||
    (normalizedName.includes("lipogram") ? "/customer/clinic/lipogram-test" : null) ||
    (normalizedName.includes("peak flow") ? "/customer/clinic/peak-flow-test" : null) ||
    (normalizedName.includes("urine dipstick") ? "/customer/clinic/urine-dipstick-test" : null) ||
    (normalizedName.includes("haemoglobin") || normalizedName.includes("hemoglobin") ? "/customer/clinic/hemoglobin-test" : null) ||
    (normalizedName.includes("hiv") ? "/customer/clinic/hiv-test" : null) ||
    (normalizedName.includes("ear syringing") ? "/customer/clinic/ear-syringing" : null) ||
    (normalizedName.includes("wound care") ? "/customer/clinic/wound-care" : null) ||
    (normalizedName.includes("nebul") ? "/customer/clinic/nebulisation" : null) ||
    (normalizedName.includes("pap smear") ? "/customer/clinic/pap-smear" : null) ||
    (normalizedName.includes("family planning") ? "/customer/clinic/family-planning" : null) ||
    (normalizedName.includes("baby immun") || normalizedName.includes("immunisation") || normalizedName.includes("immunization")
      ? "/customer/clinic/baby-immunization"
      : null) ||
    (normalizedName.includes("diet consult") ? "/customer/clinic/diet-consult-weekly" : null) ||
    (normalizedName.includes("diet plus") ? "/customer/clinic/diet-plus-injection" : null) ||
    (normalizedName.includes("diabetes") ? "/customer/clinic/diabetes-consult" : null) ||
    (normalizedName.includes("health risk") ? "/customer/clinic/health-risk-assessment" : null) ||
    (normalizedName.includes("metabolic") || normalizedName.includes("menopause") ? "/customer/clinic/metabolic-consult" : null) ||
    (normalizedName.includes("momentum") || normalizedName.includes("multiply hra") ? "/customer/clinic/momentum-hra" : null) ||
    (normalizedName.includes("discovery vitality") ? "/customer/clinic/discovery-vitality" : null) ||
    (normalizedName.includes("wellness screening") ? "/customer/clinic/wellness-screening" : null);

  const isInjectionService =
    normalizedCode === "ADMIN" ||
    normalizedCode === "ADMIN PEAK" ||
    normalizedName.includes("injection");

  const isDietPlusInjectionService = normalizedCode === "DIET PLUS" || normalizedName.includes("diet plus");

  const isCardiometabolicScreeningService =
    normalizedCode === "HIV" ||
    normalizedCode === "DIABETES" ||
    normalizedCode === "HEART" ||
    normalizedCode === "STROKE" ||
    normalizedName.includes("hiv") ||
    normalizedName.includes("diabetes") ||
    normalizedName.includes("heart disease") ||
    normalizedName.includes("stroke");

  const isAdultVaccinationService =
    normalizedCode === "VACC ADULT" ||
    normalizedName.includes("vaccination adult") ||
    normalizedName.includes("vaccination (18") ||
    normalizedName.includes("18 years");

  const isMinorVaccinationService =
    normalizedCode === "VACC MINOR" ||
    normalizedCode === "BABY ADMIN" ||
    normalizedName.includes("minor vaccination") ||
    normalizedName.includes("vaccination minor") ||
    normalizedName.includes("baby immunisation") ||
    normalizedName.includes("baby immunization") ||
    normalizedName.includes("immunisation administration") ||
    normalizedName.includes("immunization administration") ||
    normalizedName.includes("minor");

  const isFamilyPlanningService =
    normalizedCode === "FAMILY PLANNING" ||
    normalizedName.includes("family planning");

  if (isInjectionService) {
    return {
      route: "/customer/clinic/consent/injection-administration",
      continueTo: routeForService || "/customer/clinic/injection",
    };
  }

  if (isDietPlusInjectionService) {
    return {
      route: "/customer/clinic/consent/injection-administration",
      continueTo: routeForService || "/customer/clinic/diet-plus-injection",
    };
  }

  if (isCardiometabolicScreeningService) {
    return {
      route: "/customer/clinic/consent/cardiometabolic-screening",
      continueTo: routeForService || "/customer/clinic/patient-overview",
    };
  }

  if (isAdultVaccinationService) {
    return {
      route: "/customer/clinic/consent/vaccination-adult",
      continueTo: routeForService || "/customer/clinic/patient-overview",
    };
  }

  if (isMinorVaccinationService) {
    return {
      route: "/customer/clinic/consent/vaccination-minor",
      continueTo: routeForService || "/customer/clinic/baby-immunization",
    };
  }

  if (isFamilyPlanningService) {
    return {
      route: "/customer/clinic/consent/family-planning",
      continueTo: null, // Stay in consent form, don't auto-navigate to treatment
    };
  }

  return { route: routeForService || "/customer/clinic/patient-overview", continueTo: null };
};
